export function loginDestination(search: string) {
  const destination = new URLSearchParams(search).get('redirectUrl') || '/'
  return destination.startsWith('/') &&
    !destination.startsWith('//') &&
    !/[\\\s]/.test(destination) &&
    !/^\/(?:login|signin|verify|forgot-password|reset-password)(?:[/?#]|$)/.test(destination)
    ? destination
    : '/'
}

export function passwordlessSignInPath(search = '') {
  const destination = loginDestination(search)
  return destination === '/' ? '/signin/' : `/signin/?redirectUrl=${encodeURIComponent(destination)}`
}

export function redirectLegacyPasswordPage() {
  if (!/^\/(?:login|forgot-password|reset-password)\/?$/.test(window.location.pathname)) return
  // Discard old invitation/reset credentials before analytics or API requests run.
  const search = window.location.pathname.replace(/\/$/, '') === '/login' ? window.location.search : ''
  window.history.replaceState(window.history.state, '', passwordlessSignInPath(search))
}
